<template>
  <div class="add" @keyup.13="submit">
    <mu-dialog title="新增用户" width="500" :open="open" @close="close">
      <mu-form :model="form" label-position="left" label-width="80" ref="form">
        <mu-form-item prop="userName" label="用户名">
          <mu-text-field v-model="form.userName"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="realName" label="真实姓名">
          <mu-text-field v-model="form.realName"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="type" label="用户类型">
          <mu-radio value="员工" v-model="form.type" label="员工"></mu-radio>
          <mu-radio value="客户" v-model="form.type" label="客户"></mu-radio>
          <mu-radio
            value="管理员"
            v-model="form.type"
            label="管理员"
          ></mu-radio>
        </mu-form-item>

        <mu-form-item prop="phone" label="手机号">
          <mu-text-field v-model="form.phone"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="role" label="角色">
          <mu-select v-model="form.role.id" @change="roleChange">
            <mu-option
              v-for="(item, index) in roleList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></mu-option>
          </mu-select>
        </mu-form-item>
      </mu-form>
      <mu-button slot="actions" flat color="secondary" @click="close"
        >取消</mu-button
      >
      <mu-button slot="actions" color="primary" @click="submit">提交</mu-button>
    </mu-dialog>
  </div>
</template>

<script>
import backend from 'utils/backend'
import api from '@/api'
export default {
  props: {
    open: {
      tpye: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        userName: '',
        realName: '',
        phone: '',
        role: {
          id: 1
        },
        type: ''
      },
      roleList: []
    }
  },
  methods: {
    submit() {
      this.$refs.form.validate().then((flag) => {
        if (flag) {
          backend(api.user.create, this.form).then((result) => {
            if (result.statusCode === 200) {
              this.close()
              this.$emit('finish')
              this.form = {
                userName: '',
                realName: '',
                phone: '',
                role: {
                  id: 1
                },
                type: ''
              }
            }
          })
        }
      })
    },
    close() {
      this.$emit('update:open', false)
    },
    getAllRole() {
      backend(api.role.getAll, { getAll: true }).then((res) => {
        if (res.statusCode === 200) {
          this.roleList = res.data.rows
        }
      })
    },
    roleChange(roleId) {
      this.form.role = this.roleList.find((x) => x.id === roleId)
    }
  },
  mounted() {
    this.getAllRole()
  }
}
</script>

<style lang="less" scoped>
.add {
}
</style>



// WEBPACK FOOTER //
// src/views/user/create.vue